import React from "react";

/**
 * Fixed, non-interactive site backdrop: deep gradient + drifting accent blobs.
 * Pure CSS — no canvas, no dependency.
 */
function Background() {
  return (
    <div className="pointer-events-none fixed inset-0 -z-10 overflow-hidden bg-bg">
      <div className="absolute inset-0 grid-backdrop opacity-60" />
      <div className="absolute -top-40 -left-32 h-[38rem] w-[38rem] rounded-full bg-accent/20 blur-[130px] animate-blob-drift" />
      <div
        className="absolute top-1/3 -right-40 h-[32rem] w-[32rem] rounded-full bg-indigo-500/15 blur-[130px] animate-blob-drift"
        style={{ animationDelay: "-6s" }}
      />
      <div
        className="absolute bottom-0 left-1/4 h-[30rem] w-[30rem] rounded-full bg-fuchsia-500/10 blur-[130px] animate-blob-drift"
        style={{ animationDelay: "-12s" }}
      />
      <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_top,_transparent_0%,_rgba(11,11,18,0.4)_60%,_#0b0b12_100%)]" />
    </div>
  );
}

export default Background;
